import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import "./doc_consultation_js.js";
import "./doc_consultation_css.css";
import ServiceShowcase from "../ServiceShowCase.jsx";
import CardSlider from "../CardSlider.jsx";
import banner from "../../Assets/cover.png";
import ServicesGrid from "../ServiceGrid.jsx";
import CardsContainer from "../CardsContainer.jsx";
import Testimonials from "../../Testimonial/Testimonial.jsx";
import CoverHero from "../CoverHero.jsx";
import { useState } from "react";
import LoginModal from "../../Modals/LoginModal.js";
import {
  serviceShowcaseData,
  chooseexcellence_data,
  causeServices,
  causeheading,
  causesubheading,
  assistanceheading,
  assistanceservices,
  relax_data,
  unmachedheading,
  unmachedservices,
  doc_conc_testimonials,
} from "./doc_consultation_js.js";
import { useNavigate } from "react-router-dom";

const DoctorConsultation = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <CoverHero image={banner} title="Doctor Consultation" />
      <div className="servicesShowCase">
        {serviceShowcaseData.map((service, index) => (
          <ServiceShowcase
            key={index}
            className="medical-equ doc-showcase"
            data={service}
            onServiceClick={() => navigate('/')}

          />
        ))}
      </div>

      <div className="choose-excellence grey-bg mt-40px">
        <div className="excellence-content">
          <div className="blend-container">
            <h2 className="excellence-title second-title">
              {chooseexcellence_data.title}
            </h2>
            <h3 className="subtitle-h3">{chooseexcellence_data.subheading}</h3>
            <p>{chooseexcellence_data.para1}</p>
          </div>

          <div className="image-container">
            <img
              src={chooseexcellence_data.image}
              alt={chooseexcellence_data.title}
            />
          </div>
        </div>
      </div>
      <CardsContainer
        heading={causeheading}
        subheading={causesubheading}
        services={Object.values(causeServices)}
        className="white-bg medical-equ-cardscontainer"
      />

      <CardSlider heading={assistanceheading} data={assistanceservices} />

      <div className="choose-excellence white-bg">
        <div className="excellence-content">
          <div className="blend-container">
            <h2 className="excellence-title second-title">
              {relax_data.title}
            </h2>
            <h3 className="subtitle-h3">{relax_data.subheading}</h3>
            <p>{relax_data.para1}</p>
          </div>

          <div className="image-container">
            <img src={relax_data.image} alt={relax_data.title} />
          </div>
        </div>
      </div>
      <CardsContainer
        heading={unmachedheading}
        services={Object.values(unmachedservices)}
      />
      <div className="excellence-testimonials-container">
        <Testimonials
          data={doc_conc_testimonials}
          textKey="desc"
          imgKey="userimg"
          nameKey="username"
          className="white-bg"
        />
        <ServicesGrid
          title="Check Our Other Services"
          exclude="Doctor Consultation"
        />
        <Footer />
      </div>
    </>
  );
};

export default DoctorConsultation;
